import InboxSim from "./InboxSim";
import FileExplorerSim from "./FileExplorerSim";
import SearchSim from "./SearchSim";
import AIChatSim from "./AIChatSim";
import SettingsSim from "./SettingsSim";
import IncidentSim from "./IncidentSim";
import EditorSim from "./EditorSim";
import TaskSim from "./TaskSim";

const MAP = {
  inbox: InboxSim,
  fileExplorer: FileExplorerSim,
  search: SearchSim,
  aiChat: AIChatSim,
  settings: SettingsSim,
  incident: IncidentSim,
  editor: EditorSim,
  task: TaskSim,
};

export default function SimulationRunner({ simType, scenario, recorder, onFinalize, busy }) {
  const Comp = MAP[simType];
  if (!Comp) {
    return (
      <div className="p-6">
        <div className="label-mono text-cs">Unknown simulation type: {simType}</div>
      </div>
    );
  }
  return <Comp scenario={scenario} recorder={recorder} onFinalize={onFinalize} busy={busy} />;
}
